import { render, staticRenderFns } from "./PbcCta2.vue?vue&type=template&id=57beac1a&scoped=true&"
import script from "./PbcCta2.vue?vue&type=script&lang=js&"
export * from "./PbcCta2.vue?vue&type=script&lang=js&"
import style0 from "./PbcCta2.vue?vue&type=style&index=0&id=57beac1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57beac1a",
  null
  
)

export default component.exports